import React from 'react';
import Leads from '../../../components/Leads/index'

export const ContactForm = props => {
  const { id, thankYou } = props
  return (
    <Leads thankYou={thankYou} id={id}/>
  );
};
